<template>
  <div>
    <div class="title-box">
      <p class="title">解决方案</p>
      <p class="remarks">针对新零售行业各应用场景运营难题，以“数据中台+行业SaaS”输出解决方案，加速产业互联网融合</p>
      <ul class="content">
        <li class="active-box">
          <div class="active" :style="{'left': left+'rem'}"></div>
        </li>
        <li @mouseenter="activeFn(0)" @click="$router.push('/amusement')" @mouseleave="activeFn(-3.22)">
          <img src="@/assets/images/solution/1.png" alt="" class="p1">
          <p class="img-title pt-17">游乐场</p>
        </li>
        <li @mouseenter="activeFn(3.4)">
          <p class="line"></p>
        </li>
        <li @mouseenter="activeFn(3.4)"  @click="$router.push('/equipment')" @mouseleave="activeFn(6.44)">
          <img src="@/assets/images/solution/2.png" alt="" class="p2">
          <p class="img-title pt-33">设备运营商</p>
        </li>
      </ul>
    </div>
    <div class="core-box">
      <p class="title-core">核心优势</p>
      <ul class="core">
        <li>
          <img src="@/assets/images/solution/3.png" alt="" class="p3">
          <p class="core-title">产品成熟</p>
          <p class="core-content">经过十余年的技术沉淀，历经餐饮教育、游乐等行业验证，功能的全面性系统的稳定性都已成熟</p>
        </li>
        <li>
          <img src="@/assets/images/solution/4.png" alt="" class="p3">
          <p class="core-title">技术过硬</p>
          <p class="core-content">公司在所处行业率先推出7X24小时服务体系，且在华北、华中、西南、华南等地常驻服务团队，全力保障客户服务</p>
        </li>
        <li>
          <img src="@/assets/images/solution/5.png" alt="" class="p3">
          <p class="core-title">团队实力</p>
          <p class="core-content">核心团队的人才大多来自于阿里巴巴金蝶、华为、富士康等知名互联网企业，产品研发及技术实力雄厚</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      left: -3.22
    }
  },
  methods: {
    activeFn (number) {
      console.log(number)
      this.left = number
    }
  }
}
</script>

<style scoped>
  .title-box{
    width: 100%;
    background:rgba(88,141,255,1);
    padding: 81px 371px 0;
    height: 550px;
    box-sizing: border-box;
  }
  .core-box{
    padding: 223px 388px 113px;
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
  }
  .title{
    font-size:35px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:61px;
    color:rgba(255,255,255,1);
    opacity:1;
  }
  .remarks{
    font-size:21px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:61px;
    color:rgba(255,255,255,1);
    opacity:0.7;
    margin-bottom: 38px;
    margin-top: 32px;
  }
  .line{
    width:2px;
    height:200px;
    background: rgba(198,209,230,1);
  }
  .content{
    width: 1238px;
    position: absolute;
    left: 50%;
    margin-left: -619px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    padding-bottom: 98px;
    border:1px solid rgba(206,206,206,1);
    box-sizing: border-box;
    transition: all 0.5s;
    flex-wrap: wrap;
  }
  .content>li:nth-child(2){
    padding-left: 205px;
    padding-right: 205px;
    cursor: pointer;
  }
  .content>li:last-child{
    padding-left: 205px;
    padding-right: 205px;
    cursor: pointer;
  }
  .content:hover{
    background:rgba(253,254,255,1);
    border:1px solid rgba(255,255,255,1);
    box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  }
  .img-title, .core-title{
    font-size:21px;
    font-family:PingFang SC;
    font-weight:600;
    line-height:29px;
    color:rgba(51,51,51,1);
    opacity:1;
  }
  .core{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .active-box{
    position: relative;
    width: 100%;
    height: 5px;
    margin-bottom: 90px;
    overflow: hidden;
  }
  .active{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 49%;
    background: rgba(252,189,1,1);
    transition: all 0.5s;
  }
  .title-core{
    font-size:35px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:61px;
    color:rgba(51,51,51,1);
    margin-bottom: 92px;
  }
  .core-content{
    margin-top: 10px;
    width: 320px;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:28px;
    color:rgba(135,135,135,1);
    opacity:1;
  }
  .pt-33{
    padding-top: 33px;
  }
  .pt-17{
    padding-top: 17px;
  }
  .p1{
    width:213px;
  }
  .p2{
    width: 193px;
  }
  .p3{
    width: 107px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/solution.vue